import type { TypedAction } from "../../../generic/redux/TypedRedux";

import {
	CHANGE_TAB,
	CHANGE_TIMEOUT,
	CLEAR_QUERY,
	EXECUTE_QUERY,
	QUERY_CHANGED,
	QUERY_ERROR,
	QUERY_RESULT_CHANGED,
} from "./AnalyticsActionTypes";
import type { ResultType } from "./AnalyticsQuery";
import type { AnalyticsContentTab } from "./AnalyticsState";

interface QueryData {
	query: string;
}

export type ExecuteQuery = TypedAction<typeof EXECUTE_QUERY>;
export const executeQuery = (): ExecuteQuery => ({ type: EXECUTE_QUERY });

export type QueryChanged = QueryData & TypedAction<typeof QUERY_CHANGED>;
export const queryChanged = (query: string): QueryChanged => ({
	type: QUERY_CHANGED,
	query,
});

interface ChangeTimeoutData {
	timeout: number;
}

export type ChangeTimeout = ChangeTimeoutData & TypedAction<typeof CHANGE_TIMEOUT>;
export const changeTimeout = (timeout: number): ChangeTimeout => ({
	type: CHANGE_TIMEOUT,
	timeout,
});

interface QueryResultChangedData {
	data: any;
	dataType: ResultType;
}

export type QueryResultChanged = QueryResultChangedData & TypedAction<typeof QUERY_RESULT_CHANGED>;
export const queryResultChanged = (data: any, dataType: ResultType): QueryResultChanged => ({
	type: QUERY_RESULT_CHANGED,
	data,
	dataType,
});

interface QueryErrorData {
	error: string;
}

export type QueryError = QueryErrorData & TypedAction<typeof QUERY_ERROR>;

export const queryError = (error: string): QueryError => ({
	type: QUERY_ERROR,
	error,
});

export type ClearQuery = TypedAction<typeof CLEAR_QUERY>;
export const clearQuery = (): ClearQuery => ({ type: CLEAR_QUERY });

interface ChangeTabData {
	tabName: AnalyticsContentTab;
}
export type ChangeTab = ChangeTabData & TypedAction<typeof CHANGE_TAB>;
export const changeTab = (tabName: AnalyticsContentTab): ChangeTab => ({ type: CHANGE_TAB, tabName });
